// extracted by mini-css-extract-plugin
export default {"rating":"HG-z","numberOfStars":"IG-z","count":"JG-z","barGraphSpacing":"KG-z","barGraph":"LG-z"};